class StringUtils {
    static EMPTY = '';
    static SPACE = ' ';

    static isEmpty(value) {
        return value == null || value.length === 0;
    }

    static isNotEmpty(value) {
        return !StringUtils.isEmpty(value);
    }

    static isBlank(value) {
        if (value == null) {
            return true;
        }

        if (typeof value !== 'string') {
            return false;
        }

        let trimmedValue = value.trim();
        return trimmedValue.length === 0;
    }

    static isNotBlank(value) {
        return !StringUtils.isBlank(value);
    }

    static toCapitalizedWords(value) {
        var words = value.match(/[A-Za-z][a-z]*/g) || [];
    
        return words.map(StringUtils.capitalize).join(" ");
    }
    
    static capitalize(value) {
        return value.charAt(0).toUpperCase() + value.substring(1);
    }

    static snakeCaseToCamelCase(word) {
        return word.replace(/(-\w)/g, matches => matches[1].toUpperCase());
    }
}

export default StringUtils;